// src/app/my-theme.ts
// Appackshadow-Bibliothek: https://getcssscan.com/css-box-shadow-examples
// PrimeUIX: https://github.com/primefaces/primeuix/tree/main/packages/themes/src/presets/aura

import Aura from '@primeng/themes/aura';
import { AuraBaseDesignTokens } from '@primeng/themes/aura/base';
import { Preset } from '@primeng/themes/types';


const AppackThemeDefault = {
    ...Aura,
    semantic: {
        ...Aura.semantic,
        primary: {
            50: '{blue.50}',
            100: '{blue.100}',
            200: '{blue.200}',
            300: '{blue.300}',
            400: '{blue.400}',
            500: '#5E81AC',
            600: '{blue.600}',
            700: '{blue.700}',
            800: '{blue.800}',
            900: '{blue.900}',
            950: '{blue.950}',
        },
        secondary: {
            50: '{slate.50}',
            100: '{slate.100}',
            200: '{slate.200}',
            300: '{slate.300}',
            400: '{slate.400}',
            500: '{slate.500}',
            600: '{slate.600}',
            700: '{slate.700}',
            800: '{slate.800}',
            900: '{slate.900}',
            950: '{slate.950}',
        },
        colorScheme: {
            ...Aura.semantic.colorScheme,
            light: {
                ...Aura.semantic.colorScheme.light,
                extend: {
                    appackGrey: {
                        0: "#f2f4f6"
                    },
                    appackShadow: {
                        36: "rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px",
                        54: "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset"
                    },
                    appackBorderRadius: {
                        standard: "6px",
                        round: "50%"
                    }
                }
            }
        }
    }
};

export function getAppackThemeDefault() : Preset<AuraBaseDesignTokens> {


    // overlay Modal
    AppackThemeDefault.semantic.overlay.modal.borderRadius = '{appackBorderRadius.standard}';
    AppackThemeDefault.semantic.overlay.modal.padding = '1.5rem';
    AppackThemeDefault.semantic.overlay.modal.shadow = '{appackShadow.36}';


    // Card
    // root
    AppackThemeDefault.components.card.root.background = '{surface.0}';
    AppackThemeDefault.components.card.root.color = '{surface.700}';
    AppackThemeDefault.components.card.root.shadow = '{appackShadow.54}';
    AppackThemeDefault.components.card.root.borderRadius = '{appackBorderRadius.standard}';
    // body
    AppackThemeDefault.components.card.body.padding = '0.5rem';
    AppackThemeDefault.components.card.body.gap = '0.5rem';


    // Panel
    // root
    AppackThemeDefault.components.panel.root.background = '{surface.0}';
    AppackThemeDefault.components.panel.root.borderColor = '{surface.0}';
    AppackThemeDefault.components.panel.root.borderRadius = '{appackBorderRadius.standard}';
    //header
    AppackThemeDefault.components.panel.header.padding = '1.125rem 1rem 1rem 1rem';
    //content
    AppackThemeDefault.components.panel.content.padding = '0 1.125rem 1.125rem 1.125rem';


    // Listbox
    // root
    AppackThemeDefault.components.listbox.root.shadow = 'none';
    AppackThemeDefault.components.listbox.root.background = '{appackGrey.0}';

    // option
    AppackThemeDefault.components.listbox.option.focusBackground = '{secondary.400}';
    AppackThemeDefault.components.listbox.option.selectedBackground = '{secondary.200}';
    AppackThemeDefault.components.listbox.option.selectedFocusBackground = '{secondary.300}';
    AppackThemeDefault.components.listbox.option.color = '{text.color}';
    AppackThemeDefault.components.listbox.option.focusColor = '{text.color}';
    AppackThemeDefault.components.listbox.option.selectedColor = '{text.color}';
    AppackThemeDefault.components.listbox.option.selectedFocusColor = '{text.color}';
    AppackThemeDefault.components.listbox.option.borderRadius = '{appackBorderRadius.standard}';


    // Dialog
    // root
    AppackThemeDefault.components.dialog.root.background = '{appackGrey.0}';
    AppackThemeDefault.components.dialog.root.shadow = '{appackShadow.36}';
    AppackThemeDefault.components.dialog.root.color = '{surface.700}';
    AppackThemeDefault.components.dialog.root.borderRadius = '{appackBorderRadius.standard}';
    // header
    AppackThemeDefault.components.dialog.header.padding = '1rem .5rem 1rem 1.5rem';
    // title
    AppackThemeDefault.components.dialog.title.fontSize = '1.25rem';
    AppackThemeDefault.components.dialog.title.fontWeight = '600';
    // content
    AppackThemeDefault.components.dialog.content.padding = '0 1.5rem 1.5rem 1.5rem';

    //fileupload
    AppackThemeDefault.components.fileupload.root.borderRadius = '{appackBorderRadius.standard}';

    //Galerie
    AppackThemeDefault.components.galleria.root.borderWidth='0px';

    // Button
    // root
    AppackThemeDefault.components.button.root.borderRadius = '{appackBorderRadius.standard}';
    AppackThemeDefault.components.button.root.roundedBorderRadius = '{appackBorderRadius.round}';
    AppackThemeDefault.components.button.root.gap = '.5rem';
    AppackThemeDefault.components.button.root.paddingX = '.75rem';
    AppackThemeDefault.components.button.root.paddingY = '.5rem';
    AppackThemeDefault.components.button.root.label.fontWeight = '400';
    AppackThemeDefault.components.button.root.focusRing.width = '2px';
    AppackThemeDefault.components.button.root.focusRing.offset = '0';
    AppackThemeDefault.components.button.root.raisedShadow = 'none';
    //colorScheme
    AppackThemeDefault.components.button.colorScheme.light.root.primary.background = '{primary.500}';
    AppackThemeDefault.components.button.colorScheme.light.root.primary.hoverBackground = '{primary.500}';
    AppackThemeDefault.components.button.colorScheme.light.root.primary.activeBackground = '{primary.500}';
    AppackThemeDefault.components.button.colorScheme.light.root.primary.borderColor = '{primary.500}';
    AppackThemeDefault.components.button.colorScheme.light.root.primary.activeBorderColor = '{gray.950}';
    AppackThemeDefault.components.button.colorScheme.light.root.primary.hoverBorderColor = 'transparent';
    AppackThemeDefault.components.button.colorScheme.light.root.primary.color = '{surface.0}';
    AppackThemeDefault.components.button.colorScheme.light.root.primary.hoverColor = '{surface.0}';
    AppackThemeDefault.components.button.colorScheme.light.root.primary.activeColor = '{surface.0}';
    AppackThemeDefault.components.button.colorScheme.light.root.primary.focusRing.color = '{gray.950}';
    AppackThemeDefault.components.button.colorScheme.light.root.primary.focusRing.shadow = 'none';

    AppackThemeDefault.components.button.colorScheme.light.root.secondary.background = '{secondary.500}';
    AppackThemeDefault.components.button.colorScheme.light.root.secondary.hoverBackground = '{secondary.500}';
    AppackThemeDefault.components.button.colorScheme.light.root.secondary.activeBackground = '{secondary.500}';
    AppackThemeDefault.components.button.colorScheme.light.root.secondary.borderColor = '{secondary.500}';
    AppackThemeDefault.components.button.colorScheme.light.root.secondary.activeBorderColor = '{gray.950}';
    AppackThemeDefault.components.button.colorScheme.light.root.secondary.hoverBorderColor = 'transparent';
    AppackThemeDefault.components.button.colorScheme.light.root.secondary.color = '{surface.0}';
    AppackThemeDefault.components.button.colorScheme.light.root.secondary.hoverColor = '{surface.0}';
    AppackThemeDefault.components.button.colorScheme.light.root.secondary.activeColor = '{surface.0}';
    AppackThemeDefault.components.button.colorScheme.light.root.secondary.focusRing.color = '{gray.950}';
    AppackThemeDefault.components.button.colorScheme.light.root.secondary.focusRing.shadow = 'none';

    AppackThemeDefault.components.button.colorScheme.light.root.danger.background = '{red.600}';
    AppackThemeDefault.components.button.colorScheme.light.root.danger.hoverBackground = '{red.600}';
    AppackThemeDefault.components.button.colorScheme.light.root.danger.activeBackground = '{red.600}';
    AppackThemeDefault.components.button.colorScheme.light.root.danger.borderColor = '{red.600}';
    AppackThemeDefault.components.button.colorScheme.light.root.danger.activeBorderColor = '{gray.950}';
    AppackThemeDefault.components.button.colorScheme.light.root.danger.hoverBorderColor = 'transparent';
    AppackThemeDefault.components.button.colorScheme.light.root.danger.color = '{surface.0}';
    AppackThemeDefault.components.button.colorScheme.light.root.danger.hoverColor = '{surface.0}';
    AppackThemeDefault.components.button.colorScheme.light.root.danger.activeColor = '{surface.0}';
    AppackThemeDefault.components.button.colorScheme.light.root.danger.focusRing.color = '{gray.950}';
    AppackThemeDefault.components.button.colorScheme.light.root.danger.focusRing.shadow = 'none';

    AppackThemeDefault.components.button.colorScheme.light.text.primary.hoverBackground = 'transparent';
    AppackThemeDefault.components.button.colorScheme.light.text.primary.activeBackground = 'transparent';

    AppackThemeDefault.components.button.colorScheme.light.text.secondary.hoverBackground = 'transparent';
    AppackThemeDefault.components.button.colorScheme.light.text.secondary.activeBackground = 'transparent';

    AppackThemeDefault.components.button.colorScheme.light.text.danger.hoverBackground = 'transparent';
    AppackThemeDefault.components.button.colorScheme.light.text.danger.activeBackground = 'transparent';
    AppackThemeDefault.components.button.colorScheme.light.text.danger.color = '{red.600}';

    AppackThemeDefault.components.button.colorScheme.light.text.success.hoverBackground = 'transparent';
    AppackThemeDefault.components.button.colorScheme.light.text.success.activeBackground = 'transparent';
    AppackThemeDefault.components.button.colorScheme.light.text.success.color = '{green.700}';

    // Checkbox
    // root
    AppackThemeDefault.components.checkbox.root.borderRadius = '{appackBorderRadius.standard}';
    AppackThemeDefault.components.checkbox.root.background = '{surface.0}';
    AppackThemeDefault.components.checkbox.root.checkedBackground = '{secondary.500}';
    AppackThemeDefault.components.checkbox.root.checkedHoverBackground = '{secondary.500}';
    AppackThemeDefault.components.checkbox.root.disabledBackground = '{secondary.200}';
    AppackThemeDefault.components.checkbox.root.filledBackground = '{secondary.500}';
    AppackThemeDefault.components.checkbox.root.borderColor = '{secondary.500}';
    AppackThemeDefault.components.checkbox.root.hoverBorderColor = '{secondary.500}';
    AppackThemeDefault.components.checkbox.root.focusBorderColor = '{secondary.500}';
    AppackThemeDefault.components.checkbox.root.checkedBorderColor = '{secondary.500}';
    AppackThemeDefault.components.checkbox.root.checkedHoverBorderColor = '{secondary.500}';
    AppackThemeDefault.components.checkbox.root.checkedFocusBorderColor = '{secondary.500}';
    AppackThemeDefault.components.checkbox.root.checkedDisabledBorderColor = '{secondary.200}';
    AppackThemeDefault.components.checkbox.root.invalidBorderColor = '{red.600}';
    AppackThemeDefault.components.checkbox.root.shadow = 'none';
    AppackThemeDefault.components.checkbox.root.focusRing.width = '2px';
    AppackThemeDefault.components.checkbox.root.focusRing.color = '{gray.950}';
    AppackThemeDefault.components.checkbox.root.focusRing.offset = '0';
    AppackThemeDefault.components.checkbox.root.focusRing.shadow = 'none';
    //icon
    AppackThemeDefault.components.checkbox.icon.size = '0.75rem';
    AppackThemeDefault.components.checkbox.icon.color = '{secondary.500}';
    AppackThemeDefault.components.checkbox.icon.checkedColor = '{surface.0}';
    AppackThemeDefault.components.checkbox.icon.checkedHoverColor = '{surface.0}';
    AppackThemeDefault.components.checkbox.icon.disabledColor = '{surface.0}';


    // Radiobutton
    // root
    AppackThemeDefault.components.radiobutton.root.background = '{surface.0}';
    AppackThemeDefault.components.radiobutton.root.checkedBackground = '{secondary.500}';
    AppackThemeDefault.components.radiobutton.root.checkedHoverBackground = '{secondary.500}';
    AppackThemeDefault.components.radiobutton.root.disabledBackground = '{secondary.200}';
    AppackThemeDefault.components.radiobutton.root.filledBackground = '{secondary.500}';
    AppackThemeDefault.components.radiobutton.root.borderColor = '{secondary.500}';
    AppackThemeDefault.components.radiobutton.root.hoverBorderColor = '{secondary.500}';
    AppackThemeDefault.components.radiobutton.root.focusBorderColor = '{secondary.500}';
    AppackThemeDefault.components.radiobutton.root.checkedBorderColor = '{secondary.500}';
    AppackThemeDefault.components.radiobutton.root.checkedHoverBorderColor = '{secondary.500}';
    AppackThemeDefault.components.radiobutton.root.checkedFocusBorderColor = '{secondary.500}';
    AppackThemeDefault.components.radiobutton.root.checkedDisabledBorderColor = '{secondary.200}';
    AppackThemeDefault.components.radiobutton.root.invalidBorderColor = '{red.600}';
    AppackThemeDefault.components.radiobutton.root.shadow = 'none';
    AppackThemeDefault.components.radiobutton.root.focusRing.width = '2px';
    AppackThemeDefault.components.radiobutton.root.focusRing.color = '{gray.950}';
    AppackThemeDefault.components.radiobutton.root.focusRing.offset = '0';
    AppackThemeDefault.components.radiobutton.root.focusRing.shadow = 'none';
    //icon
    AppackThemeDefault.components.radiobutton.icon.size = '0.75rem';
    AppackThemeDefault.components.radiobutton.icon.checkedColor = '{surface.0}';
    AppackThemeDefault.components.radiobutton.icon.checkedHoverColor = '{surface.0}';
    AppackThemeDefault.components.radiobutton.icon.disabledColor = '{surface.0}';

    // Text Input
    // root
    AppackThemeDefault.components.inputtext.root.shadow = 'none';
    AppackThemeDefault.components.inputtext.root.borderRadius = '{appackBorderRadius.standard}';
    AppackThemeDefault.components.inputtext.root.background = '{surface.0}';
    AppackThemeDefault.components.inputtext.root.paddingY = '.5rem';
    AppackThemeDefault.components.inputtext.root.paddingX = '.5rem';
    AppackThemeDefault.components.inputtext.root.borderColor = '{secondary.300}';
    AppackThemeDefault.components.inputtext.root.hoverBorderColor = '{secondary.500}';
    AppackThemeDefault.components.inputtext.root.focusBorderColor = '{secondary.700}';
    AppackThemeDefault.components.inputtext.root.invalidBorderColor = '{red.600}';


    // Select
    // root
    AppackThemeDefault.components.select.root.borderColor = '{secondary.300}';
    AppackThemeDefault.components.select.root.hoverBorderColor = '{secondary.500}';
    AppackThemeDefault.components.select.root.focusBorderColor = '{secondary.700}';
    AppackThemeDefault.components.select.root.invalidBorderColor = '{red.600}';
    // option
    AppackThemeDefault.components.select.option.selectedBackground = '{secondary.300}';
    AppackThemeDefault.components.select.option.selectedFocusBackground = '{secondary.300}';
    AppackThemeDefault.components.select.option.color = '{secondary.500}';
    AppackThemeDefault.components.select.option.focusColor = '{secondary.500}';
    AppackThemeDefault.components.select.option.selectedColor = '{secondary.500}';
    AppackThemeDefault.components.select.option.selectedFocusColor = '{secondary.500}';

    // Multiselect
    // root
    AppackThemeDefault.components.multiselect.root.borderColor = '{secondary.300}';
    AppackThemeDefault.components.multiselect.root.hoverBorderColor = '{secondary.500}';
    AppackThemeDefault.components.multiselect.root.focusBorderColor = '{secondary.700}';
    AppackThemeDefault.components.multiselect.root.invalidBorderColor = '{red.600}';
    // option
    AppackThemeDefault.components.multiselect.option.selectedBackground = '{secondary.300}';
    AppackThemeDefault.components.multiselect.option.selectedFocusBackground = '{secondary.300}';
    AppackThemeDefault.components.multiselect.option.color = '{secondary.500}';
    AppackThemeDefault.components.multiselect.option.focusColor = '{secondary.500}';
    AppackThemeDefault.components.multiselect.option.selectedColor = '{secondary.500}';
    AppackThemeDefault.components.multiselect.option.selectedFocusColor = '{secondary.500}';

    // Tag
    // root
    AppackThemeDefault.components.tag.root.fontSize = '.75rem';
    AppackThemeDefault.components.tag.root.fontWeight = '600';
    AppackThemeDefault.components.tag.root.padding = '0.25rem 0.5rem';
    AppackThemeDefault.components.tag.root.gap = '1rem';
    AppackThemeDefault.components.tag.root.borderRadius = '{appackBorderRadius.standard}';

    // colorScheme
    AppackThemeDefault.components.tag.colorScheme.light.primary.color = '{surface.0}';
    AppackThemeDefault.components.tag.colorScheme.light.primary.background = '{primary.500}';
    AppackThemeDefault.components.tag.colorScheme.light.secondary.color = '{surface.0}';
    AppackThemeDefault.components.tag.colorScheme.light.secondary.background = '{secondary.500}';
    AppackThemeDefault.components.tag.colorScheme.light.success.color = '{surface.0}';
    AppackThemeDefault.components.tag.colorScheme.light.success.background = '{green.700}';
    AppackThemeDefault.components.tag.colorScheme.light.info.color = '{surface.0}';
    AppackThemeDefault.components.tag.colorScheme.light.info.background = '{sky.700}';
    AppackThemeDefault.components.tag.colorScheme.light.warn.color = '{surface.0}';
    AppackThemeDefault.components.tag.colorScheme.light.warn.background = '{orange.700}';
    AppackThemeDefault.components.tag.colorScheme.light.danger.color = '{surface.0}';
    AppackThemeDefault.components.tag.colorScheme.light.danger.background = '{red.600}';
    AppackThemeDefault.components.tag.colorScheme.light.contrast.color = '{surface.0}';
    AppackThemeDefault.components.tag.colorScheme.light.contrast.background = '{surface.950}';


    // Tabs
    // item
    AppackThemeDefault.components.tabs.tab.color = '{text.color}';
    AppackThemeDefault.components.tabs.tab.hoverColor = '{text.color}';
    AppackThemeDefault.components.tabs.tab.activeColor = '{text.color}';
    AppackThemeDefault.components.tabs.tab.padding = '1rem';
    AppackThemeDefault.components.tabs.tab.borderColor = 'transparent';

    //tablist
    AppackThemeDefault.components.tabs.tablist.background = "{surface.0}";
    // not überprüfung für die tabs liste im CMS
    AppackThemeDefault.components.tabs.css =  ({ dt }) => `
        .p-tabs:not(.topbarTabMenu ){
            .p-tablist-content{
                background-color: var(--p-surface-0);
            }
        }
    `


    //Toast
    //colorScheme
    AppackThemeDefault.components.toast.colorScheme.light.info.color = '{text.color}';
    AppackThemeDefault.components.toast.colorScheme.light.success.color = '{text.color}';
    AppackThemeDefault.components.toast.colorScheme.light.warn.color = '{text.color}';
    AppackThemeDefault.components.toast.colorScheme.light.error.color = '{text.color}';
    AppackThemeDefault.components.toast.colorScheme.light.secondary.color = '{text.color}';
    AppackThemeDefault.components.toast.colorScheme.light.contrast.color = '{text.color}';

    //Toolbar
    //colorScheme
    AppackThemeDefault.components.toolbar.root.background = 'none'

    //Drawer
    //header
    AppackThemeDefault.components.drawer.header.padding = '1rem';

    //Accordion
    //header
    AppackThemeDefault.components.accordion.header.background = '{appackGrey.0}';
    AppackThemeDefault.components.accordion.header.hoverBackground = '{appackGrey.0}';
    AppackThemeDefault.components.accordion.header.activeBackground = '{appackGrey.0}';
    AppackThemeDefault.components.accordion.header.activeHoverBackground = '{appackGrey.0}';
    AppackThemeDefault.components.accordion.header.color = '{text.color}';
    AppackThemeDefault.components.accordion.header.toggleIcon.color = '{text.color}';
    AppackThemeDefault.components.accordion.header.toggleIcon.hoverColor = '{text.color}';
    AppackThemeDefault.components.accordion.header.toggleIcon.activeColor = '{text.color}';
    AppackThemeDefault.components.accordion.header.toggleIcon.activeHoverColor = '{text.color}';
    AppackThemeDefault.components.accordion.header.padding = '.75rem 1rem';
    //content
    AppackThemeDefault.components.accordion.content.padding = '.5rem 1rem';
    //panel
    AppackThemeDefault.components.accordion.panel.borderWidth = '0';

    //Togglebutton
    //colorScheme
    AppackThemeDefault.components.togglebutton.colorScheme.light.root.background = '{surface.0}';

    //Stepper
    //stepNumber
    AppackThemeDefault.components.stepper.stepNumber.activeColor = '{text.color}';


     //datatabl
    AppackThemeDefault.components.datatable.headerCell.background = 'var(--surface-ground)';
    AppackThemeDefault.components.datatable.row.hoverBackground = 'var(--p-datatable-row-background)';
    AppackThemeDefault.components.datatable.row.selectedBackground = '{secondary.200}';
    AppackThemeDefault.components.datatable.row.selectedColor = '{text.color}';
    AppackThemeDefault.components.datatable.headerCell.color = '{primary.500}';
    AppackThemeDefault.components.datatable.headerCell.selectedColor = '{primary.500}';
    AppackThemeDefault.components.datatable.headerCell.selectedBackground = '{appackGrey.0}';
    AppackThemeDefault.components.datatable.headerCell.hoverColor = '{primary.400}';
    AppackThemeDefault.components.datatable.headerCell.background = '{appackGrey.0}'
    AppackThemeDefault.components.datatable.header.background = '{appackGrey.0}'
    AppackThemeDefault.components.datatable.headerCell.color = '{text.color}';
    AppackThemeDefault.components.datatable.row.color = '{text.color}';

    AppackThemeDefault.components.multiselect.option.selectedBackground = '{appackGrey.0}';
    AppackThemeDefault.components.multiselect.option.selectedFocusBackground = '{appackGrey.0}';

    //toggle switch

    AppackThemeDefault.components.toggleswitch.colorScheme.light.root.checkedHoverBackground = '{primary.500}'

    // Listbox
    AppackThemeDefault.components.listbox.root.background = "{appack.grey}";
    AppackThemeDefault.components.listbox.root.borderColor = "{appack.grey}";
    AppackThemeDefault.components.listbox.list.gap = "0.5rem";
    AppackThemeDefault.components.listbox.option.padding = "1rem";
    AppackThemeDefault.components.listbox.list.header.padding = "0 0.25rem 1rem 0.25rem";
    AppackThemeDefault.components.listbox.css =  ({ dt }) => `
        .p-listbox-option{
            background-color: var(--p-surface-0);
        }
        .p-listbox-list-container{
            max-height: inherit !important;
        }
    `


    /**
     * lässt sich nicht direkt über tokens designen
     * @param param
     * @returns
     */
    AppackThemeDefault.components.selectbutton.css =  ({ dt }) => `
        .p-selectbutton{
            background: ${dt('surface-0')};
            padding: 0.1rem;
        }
        .p-togglebutton{
            border: none !important;
        }
        .p-togglebutton-checked{
            background: ${dt('surface-0')} !important;
            .p-togglebutton-content{
                background: ${dt('button-primary-background')} !important;
                color: ${dt('button-primary-color')} !important;
                }
        }
        .p-togglebutton-content{
            background: ${dt('surface-0')} !important;
        }
        .p-togglebutton:not(:disabled):not(.p-togglebutton-checked):hover{
            background: ${dt('surface-0')} !important;
        }
    `


    /**
     * blockui
     */
    AppackThemeDefault.components.blockui.root.borderRadius = '0px'
    return AppackThemeDefault;
}
